import styled from '@emotion/styled';
import { isDefaultFieldValue } from '../utils';
import { Campaign } from './Campaign';
import { NotFound } from './NotFound';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: auto 0;

    @media (max-width: 768px) {
        height: auto;
    }
`;

interface Props {
    campaignId?: string;
    clientKey?: string;
    UID?: string;
    embed: boolean;
    inputFields?: Record<string, string>;
}

export const Content = ({ campaignId, clientKey, UID, embed, inputFields }: Props) => {
    const isUIDValid = UID && !isDefaultFieldValue({ key: 'UID', value: UID });

    if (!campaignId || !clientKey || !isUIDValid) {
        return (
            <Container>
                <NotFound />
            </Container>
        );
    }

    return (
        <Container>
            <Campaign campaignId={campaignId} clientKey={clientKey} UID={UID} inputFields={inputFields} embed={embed} />
        </Container>
    );
};
